import React from "react";
import {
  sectionCardClass,
  sectionTitleClass,
  labelClass,
  textareaClass,
} from "./tenantDetailStyles";
import { formatDateTime } from "../../../utils/datetime";

export default function TenantNotesBlock({
  notes,
  noteDraft,
  setNoteDraft,
  noteSaving,
  noteErr,
  noteSubmitError,
  onSubmit,
}) {
  return (
    <div className={sectionCardClass}>
      <div className="flex items-center justify-between border-b border-[#1c2035] px-[16px] py-[12px]">
        <div className={sectionTitleClass}>Notizen</div>
      </div>
      <div className="px-[16px] py-[14px]">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <label htmlFor="td-note" className={`${labelClass} mb-1.5`}>
            Neue Notiz
          </label>
          <textarea
            id="td-note"
            className={textareaClass}
            value={noteDraft}
            onChange={(e) => setNoteDraft(e.target.value)}
            disabled={noteSaving}
            placeholder="Interne Notiz …"
          />
          {noteErr ? (
            <div style={{ marginTop: "8px", fontSize: "13px", color: "#ff5f6d" }}>{noteErr}</div>
          ) : null}
          {noteSubmitError ? (
            <div style={{ marginTop: "8px", fontSize: "13px", color: "#ff5f6d" }}>{noteSubmitError}</div>
          ) : null}
          <div className="mt-[10px]">
            <button
              type="submit"
              disabled={noteSaving}
              className={`rounded-[6px] border border-[rgba(91,156,246,0.28)] bg-[rgba(91,156,246,0.1)] px-[14px] py-[5px] text-[11px] font-medium text-[#5b9cf6] ${
                noteSaving ? "cursor-default opacity-50" : "cursor-pointer"
              }`}
            >
              {noteSaving ? "Speichern …" : "Notiz speichern"}
            </button>
          </div>
        </form>
        <div className="mt-[10px] border-t border-[#1c2035] pt-[10px]">
          {!notes.length ? (
            <p className="m-0 text-[11px] italic text-[#4a5070]">Noch keine Notizen</p>
          ) : (
            <ul className="m-0 list-none p-0">
              {notes.map((n) => (
                <li key={n.id} className="mb-3 last:mb-0">
                  <div className="whitespace-pre-wrap text-[11px] text-[#8892b0]">{n.content}</div>
                  <div className="mt-1.5 text-[11px] text-[#4a5070]">
                    {formatDateTime(n.created_at)} · {n.author_name || "—"}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
